// src/pages/NotificationManagement/components/NotificationEmptyState.tsx
// Trạng thái rỗng - theo mục 3.4 của .features/thong-bao/ke_hoach_ui_man_thong_bao.md

import React from 'react';
import bell from '../../../assets/images/svg/bell.svg';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('notification_management');

const NotificationEmptyState: React.FC = () => (
  <div className="text-center py-5">
    <div className="mb-3">
      <img src={bell} alt={st('khong_co_thong_bao_alt')} style={{ width: 96 }} className="img-fluid" />
    </div>
    <h6 className="fs-15 fw-semibold mb-1">{st('khong_co_thong_bao_nao_title')}</h6>
    <p className="text-muted mb-0">{st('thong_bao_moi_se_xuat_hien_text')}</p>
  </div>
);

export default NotificationEmptyState;
